import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, OtpService, VerifystudentService } from '../_services';
import { Globals } from '../_helpers';
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'aadaar-otp',
    templateUrl: './aadhaar-otp.component.html'
})

export class AadhaarOtpComponent {
    otponeFormControl = new FormControl('', [
        Validators.required,
    ]);
    otptwoFormControl = new FormControl('', [
        Validators.required,
    ]);
    otpthreeFormControl = new FormControl('', [
        Validators.required,
    ]);
    otpfourFormControl = new FormControl('', [
        Validators.required,
    ]);
    otpfiveFormControl = new FormControl('', [
        Validators.required,
    ]);
    otpsixFormControl = new FormControl('', [
        Validators.required,
    ]);        
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userData = {};
    aadsettings = {};
    settings = {};
    studentid: number = 0;
    otp_type: number = 1;
    successMsg: string = '';

    full_name = '';
    aadhaar_number = '';
    dob = '';
    gender = '';
    zip = '';
    raw_xml = '';
    care_of = '';
    reference_id = '';
    country = '';
    dist = '';
    state = '';
    po = '';
    loc = '';
    vtc = '';
    subdist = '';
    street = '';
    house = '';
    landmark = '';
    exam_id: number = 0;
    batch_id: number = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private otpService: OtpService,
        private alertService: AlertService,
        private verifystudentService: VerifystudentService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient
    ) { }


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        this.studentid = parseInt(step);
        this.userData = JSON.parse(localStorage.getItem('currentUser_pc'));
        this.aadsettings = JSON.parse(sessionStorage.pkshn_aav_set_pc);       
        if(sessionStorage.pkshn_aav_set_pc == undefined)
        {
            var parms = this.globals.getRandUrl('verify');
            this.router.navigateByUrl('/verify/' + parms);
        }

        //if (step != this.globals.complSteps['otp'])
            //this.router.navigateByUrl('/login');

            // get return url from route parameters or default to '/'
          //  this.returnUrl = '/';
    }

    public otpSubmit() {
        this.successMsg = '';
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.otponeFormControl.value == '' || this.otptwoFormControl.value == '' || this.otpthreeFormControl.value == '' || this.otpfourFormControl.value == '' || this.otpfiveFormControl.value == '' || this.otpsixFormControl.value == '') {
            this.isErrorLogin = true;
            this.errorMsg = 'Please enter OTP.';
            return false;
        }
        else {
            var otp = this.otponeFormControl.value + '' + this.otptwoFormControl.value + '' + this.otpthreeFormControl.value + '' + this.otpfourFormControl.value + '' + this.otpfiveFormControl.value + '' + this.otpsixFormControl.value;

            this.loading = true;
            this.spinner.show();
            var settings = JSON.parse(sessionStorage.pkshn_exam_set_pc);
            const headers = { 'Authorization': 'Bearer '+ this.globals.aadharAPIkey};
            this.aadsettings = JSON.parse(sessionStorage.pkshn_aav_set_pc);  
            const body = { client_id: this.aadsettings['clientid'], mobile_number: this.aadsettings['mobile'], otp: otp };  
            this.http.post<any>("https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/submit-otp", body, { headers }).subscribe((res: any) => {
                if(res.status_code == 200)
                {
                    let resData = res.data;
                    sessionStorage.removeItem("pkshn_aav_set_pc");
                    this.isErrorLogin = false;
                    this.loading = false;
                    this.spinner.hide();
                    this.full_name = resData.full_name;
                    this.aadhaar_number = resData.aadhaar_number;
                    this.dob = resData.dob;
                    this.gender = resData.gender;
                    this.zip = resData.zip;
                    this.raw_xml = resData.raw_xml;
                    this.care_of = resData.care_of;
                    this.reference_id = resData.reference_id;
                    this.country = resData.country;
                    this.dist = resData.dist;
                    this.state = resData.state;
                    this.po = resData.po;
                    this.loc = resData.loc;
                    this.vtc = resData.vtc;
                    this.subdist = resData.subdist;
                    this.street = resData.street;
                    this.house = resData.house;
                    this.landmark = resData.landmark;
                    this.exam_id = settings.exam_id;
                    this.batch_id = settings.batch_id;

                    this.setverifiedData();
                    if (settings.camera == 1 && this.globals.theoryexam == 1) {
                        var parms = this.globals.getRandUrl('upload-idpic');
                        this.router.navigateByUrl('/upload-idpic/' + parms);
                    }
                    else 
                    {
                        if (settings.feedback_survey == 1) {
                           this.router.navigateByUrl('/start-feedback');                                
                        } 
                        else
                        {
                            var parms = this.globals.getRandUrl('test-start');
                            this.router.navigateByUrl('/test-start/' + parms);
                        }                                  
                    }
                }
                else
                {
                    this.isErrorLogin = true;
                    this.errorMsg = 'The OTP you entered is wrong or expired. Please re-generate OTP.';
                    this.loading = false;
                    this.spinner.hide();
                }
            },
            error => {
                this.isErrorLogin = true;
                this.errorMsg = 'The OTP you entered is wrong or expired. Please re-generate OTP.';
                //this.errorMsg = 'The aadhaar number is not correct. Please enter correct aadhaar number to verify and proceed further.';
                this.loading = false;
                this.spinner.hide();
            });            
        }
    }

    public resendOtp() {
        this.successMsg = ''; //console.log(this.aadsettings);
        this.spinner.show();
        const headers = { 'Authorization': 'Bearer '+ this.globals.aadharAPIkey};
        const body = { id_number: this.aadsettings['aadhaar'] }; 
        this.http.post<any>("https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-v2/generate-otp", body, { headers }).subscribe((res: any) => {
            if(res.status_code == 200)
            {
                let resData = res.data;
                console.log(resData);
                sessionStorage.removeItem("pkshn_aav_set_pc");
                let aadhaarsettings = { clientid: resData.client_id, mobile: this.aadsettings['mobile'], aadhaar: this.aadsettings['aadhaar'] };
                sessionStorage.setItem('pkshn_aav_set_pc', JSON.stringify(aadhaarsettings));
                this.isErrorLogin = false;
                this.successMsg = "OTP has been sent on your registered mobile."
                this.loading = false;
                this.spinner.hide();
                //this.router.navigateByUrl('/aadhaarotp');
            }
            else
            {
                this.isErrorLogin = true;
                //this.errorMsg = 'The mobile number you have entered is not correct. Please enter correct mobile number which is associated with your aadhaar number.';
                this.loading = false;
                this.spinner.hide();
            }
        },
        error => {
            this.isErrorLogin = true;
            this.errorMsg = 'Spome problem in re-sending OTP. Please try again...';
            //this.errorMsg = 'The aadhaar number is not correct. Please enter correct aadhaar number to verify and proceed further.';
            this.loading = false;
            this.spinner.hide();
        });
    }

    public setverifiedData() {
        this.successMsg = '';
        this.spinner.show();
        this.verifystudentService.setAadharData(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.exam_id, this.batch_id,                     this.full_name, this.aadhaar_number,this.dob,this.gender,this.zip,this.raw_xml,this.care_of,this.reference_id,this.country,this.dist,this.state,this.po,this.loc,this.vtc,this.subdist,this.street,this.house,this.landmark)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.isErrorLogin = false;
                        //this.successMsg = "OTP has been sent on your registered mobile."
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.isErrorLogin = false;
                        // this.router.navigateByUrl('/login');
                    }
                    else {
                        this.isErrorLogin = true;
                        //this.errorMsg = 'Otp Expire !!';
                        this.loading = false;
                    }
                    this.spinner.hide();
                },
                error => {
                    this.isErrorLogin = true;
                    //this.errorMsg = 'Otp Expire !!';
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    public keytab(event, index) {
        var textBox = document.getElementById("otp-" + index);
        textBox.focus();
    }
}
